export default __webpack_public_path__ + "static/media/ei5.c9be28a6.jpg";